 
import { FirstSectionAbout } from './components/firstSection';

export const AboutPage = () => {
    return (
        <>
            <FirstSectionAbout/>
        </>
    );
}
